import type { ISkeletonUnitProps } from './SkeletonUnit'

import { styled } from '@linaria/react'

export const SkeletonUnitSC = styled.div<ISkeletonUnitProps>`
  display: flex;
  width: ${({ width }) => width ?? 'initial'};
  min-width: ${({ width }) => width ?? 'initial'};
  height: ${({ height, width, aspectRatio }) =>
    width && aspectRatio
      ? `calc(${width} / ${aspectRatio})`
      : (height ?? 'initial')};
  flex-direction: ${({ direction }) => direction ?? 'initial'};
  align-items: ${({ alignItems }) => alignItems ?? 'initial'};
  justify-content: ${({ justifyContent }) => justifyContent ?? 'initial'};
  flex-basis: ${({ flexBasis }) => flexBasis ?? 'initial'};
  flex-grow: ${({ flexGrow }) => flexGrow ?? 'initial'};
  flex-shrink: ${({ flexShrink }) => flexShrink ?? 'initial'};
  flex-wrap: ${({ flexWrap }) => flexWrap ?? 'initial'};
  border-radius: ${({ corners }) => (corners ? `var(${corners})` : 'initial')};
  padding: ${({ paddings }) =>
    paddings && paddings.length > 0
      ? paddings.map((item) => `var(${item})`)?.join(' ')
      : 0};
  margin: ${({ margins }) =>
    margins && margins.length > 0
      ? margins.map((item) => `var(${item})`)?.join(' ')
      : 0};
  overflow: hidden;
`
